import React from 'react';
import AdminModal from 'Components/Admin/AdminModal/AdminModal';
import Button from 'Components/Admin/Button';
import useCheckIsMobile from 'Shared/hooks/useCheckIsMobile';

const AssignmentDelete = ({ history, closeUrl, match }) => {
  const isMobile = useCheckIsMobile();
  const handleClose = () => history.push(closeUrl);

  const handleDelete = () => {
    console.log('Deleting allowed: ', `assignment-${match.params.id}`);
  };

  return (
    <AdminModal
      title="Delete permanently"
      className="assignment-delete"
      testId={`assignment-delete-${match.params.id}`}
      direction={isMobile ? 'bottom' : 'top'}
      successBtn={<Button variant="simple" className="assignment-delete__btn_delete">Delete</Button>}
      onClose={handleClose}
      onSuccess={handleDelete}
    >
      <p className="assignment-delete__description">
        This assignment employee will be permanently deleted from assignment list. This <b>cannot</b> be undone.
        Are you sure you want to delete this assignment?
      </p>
    </AdminModal>
  );
};

export default AssignmentDelete;
